import { createFileRoute } from "@tanstack/react-router";
import { PageHeader } from "@/components/layout/page-header";
import { AccountSettings } from "@/features/account";
import { TrackerSettingsCard } from "@/features/tracker";

export const Route = createFileRoute("/_authenticated/me/settings")({
  component: SettingsPage,
});

function SettingsPage() {
  return (
    <div className="mx-auto max-w-4xl">
      <PageHeader
        eyebrow="My space"
        title="Settings"
        description="Your name, your title, and how you sign in."
      />
      <AccountSettings>
        <TrackerSettingsCard />
      </AccountSettings>
    </div>
  );
}
